import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import { useToast } from '../../../hooks/useToast';
import { useCreateAutomationCategory } from './queries';
import { randomCategoryColor } from '@reach/web-ui/utils';

/** Creates a partner category in a random preset color, with a failure toast. */
export function useCategoryCreator() {
  const { addToast } = useToast();
  const createCategory = useCreateAutomationCategory();

  const create = (name: string, onCreated: (category: AutomationCategoryResponse) => void) =>
    createCategory.mutate(
      { name, color: randomCategoryColor() },
      {
        onSuccess: onCreated,
        onError: (error: Error) =>
          addToast({
            title: 'Could not create the category',
            description: error.message,
            variant: 'destructive',
          }),
      },
    );

  return { create, isPending: createCategory.isPending };
}
